import ReactOnRails from 'react-on-rails';
import Form from '../bundles/Forms/Form';
import Reports from '../bundles/Reports/components/Reports';
import Login from '../bundles/Login/components/Login';
import FormNew from '../bundles/Forms/FormNew'
import ReportEdit from '../bundles/Forms/ReportEdit';
import FormEdit from '../bundles/Forms/FormEdit';
import Mixing from '../bundles/Reports/components/Mixing';
import Forms from '../bundles/Forms/Forms'
import Personal from '../bundles/Settings/Personal'
import Divisions from '../bundles/Divisions/Divisions'
import Invite from '../bundles/Settings/Invite'
import Periods from '../bundles/Periods/Periods'
import SettingsReports from '../bundles/Settings/SettingsReports'
import OnboardingStepper from '../bundles/components/OnboardingStepper'
import CreateUser from '../bundles/Settings/CreateUser'
import PasswordReset from '../bundles/components/PasswordReset'
import FormAccess from '../bundles/Settings/FormAccess'

ReactOnRails.register({
  Reports,
  Login,
  Forms,
  Form,
  FormNew,
  ReportEdit,
  FormEdit,
  Mixing,
  Personal,
  Divisions,
  Invite,
  Periods,
  SettingsReports,
  OnboardingStepper,
  CreateUser,
  PasswordReset,
  FormAccess
});
